import Api from '@/services/Api'

export default {
  index(query) {
    return Api().get('klasus', {
      params: query
    })
  },
  indexfast(query) {
    return Api().get('klasus/fast', {
      params: query
    })
  },
  show(groupId) {
    return Api().get(`klasus/${groupId}`)
  },
  post(newGroup) {
    return Api().post('klasus', newGroup)
  },
  put(group) {
    return Api().put(`klasus/${group.id}`, group)
  },
  delete(groupId) {
    return Api().delete(`klasus/${groupId}`)
  },
  choose(query) {
    return Api().get('klasus/choose', {
      params: query
    })
  }
}